<template>
  <label class="bold-xl font-family-2 t-white">
    {{ handleCurrency(getUserCurrency) }}{{ convertedPrice }}
    <span class="t-grey font-family-2 medium-m"> /1 item </span>
  </label>
</template>
<script>
import { calculateCurrency } from "~/calculate/calculatePrice";

export default {
  data() {
    return {};
  },
  props: {
    price: {
      default: 0,
    },
  },

  computed: {
    convertedPrice() {
      let conPrice = calculateCurrency(this.price, this.getUserCurrency);
      return Number.isInteger(conPrice)
        ? conPrice
        : parseFloat(conPrice).toFixed(2);
    },
  },
  setup() {
    const { getUserCurrency } = useUserStore();
    return {
      getUserCurrency,
    };
  },
};
</script>
